export default "__VITE_ASSET__9a368e04__"